import cx from 'classnames';
import { h } from 'preact';
import { intcomma } from 'journalize';

function OtherCandidate({
  isViewable,
  party,
  votes,
  totalVotes,
  candidateCount,
  onClick,
}) {
  const classes = cx('candidate contest__candidate-row', {
    'contest__candidate-row--hidden': !isViewable,
  });

  return (
    <tr class={classes}>
      <td class="candidate__cell candidate__party" />
      <th class="candidate__cell candidate__name">
        <button onClick={onClick}>
          {candidateCount} other{candidateCount > 1 && 's'}{' '}
          <svg class="icon icon-angle-down">
            <use xlinkHref="#icon-angle-down" />
          </svg>
        </button>
      </th>
      <td class="candidate__cell candidate__votes">{intcomma(votes)}</td>
      <td class="candidate__cell candidate__pct">
        {totalVotes <= 0 ? '-' : (votes / totalVotes * 100).toFixed(1)}
        <span class="candidate__pct-symbol">%</span>
      </td>
    </tr>
  );
}

export default OtherCandidate;



// WEBPACK FOOTER //
// ./components/OtherCandidate.js